import { GameLevel } from '../game-config';
import { Content, ProductError, ProductErrorType } from '../../models';

export class QuiVeutGagnerData {
  questions: QuiVeutGagnerQuestion[];
  constructor(data?: QuiVeutGagnerData) {
    this.questions = data?.questions || [].map(q => new QuiVeutGagnerQuestion(q));
  }

  static validate(data: QuiVeutGagnerData): ProductError[] {
    if (!data.questions || !data.questions.length) {
      return [{ type: ProductErrorType.MISSING, property: 'questions' }];
    } else if (data.questions.length <= 10) {
      return [{ type: ProductErrorType.NOT_ENOUGH_VALUE, property: 'questions' }];
    }
    return data.questions
      .map((question, questionIndex) => QuiVeutGagnerQuestion.validate(question, questionIndex))
      .reduce((agr, arr) => agr.concat(arr), []);
  }
}

export class QuiVeutGagnerQuestion {
  contents: Content[];
  level?: GameLevel;
  possibilities: QuiVeutGagnerPossibility[];

  // non présent dans le JSON
  index?: number;

  constructor(rawData: QuiVeutGagnerQuestion, index?: number) {
    this.contents = (rawData.contents || []).map(c => new Content(c));
    this.possibilities = rawData.possibilities.map(p => new QuiVeutGagnerPossibility(p));
    this.index = index ?? rawData.index;
    this.level = rawData.level;
  }

  static validate(question: QuiVeutGagnerQuestion, questionIndex: number): ProductError[] {
    const errors: ProductError[] = [];

    if (!question.contents || !question.contents.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'contents', payload: { questionIndex } });
    }
    question.contents
      ?.map((c, i) => Content.validate(c, i))
      .reduce((flattened, subError) => flattened.concat(subError), [])
      .forEach(error => {
        error.payload.questionIndex = questionIndex;
        errors.push(error);
      });

    if (!question.possibilities || !question.possibilities.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'possibilities', payload: { questionIndex } });
    }
    question.possibilities
      ?.map((p, i) => QuiVeutGagnerPossibility.validate(p, i))
      .reduce((flattened, subError) => flattened.concat(subError), [])
      .forEach(error => {
        error.payload.questionIndex = questionIndex;
        errors.push(error);
      });
    if (question.possibilities?.every(p => !p.isCorrect)) {
      errors.push({
        type: ProductErrorType.NOT_ENOUGH_VALUE,
        property: 'possibilities.isCorrect',
        payload: { questionIndex },
      });
    }
    return errors;
  }
}

export class QuiVeutGagnerPossibility {
  text: string;
  isCorrect: boolean;

  // non présent dans le JSON
  publicRate?: number; // vote du public
  removed?: boolean; // 50/50

  constructor(rawData: QuiVeutGagnerPossibility) {
    this.text = rawData.text;
    this.isCorrect = rawData.isCorrect;
    this.publicRate = rawData.publicRate;
    this.removed = rawData.removed;
  }

  static validate(possibility: QuiVeutGagnerPossibility, possibilityIndex: number): ProductError[] {
    if (!possibility.text) {
      return [{ property: 'text', type: ProductErrorType.MISSING, payload: { possibilityIndex } }];
    }
    return [];
  }
}
